import { useEffect, useState } from "react";
import imgfame7 from "../../../resources/img/hallFame/genph7.jpg";
import imgfame3 from "../../../resources/img/hallFame/genph3.jpg";
import imgfame6 from "../../../resources/img/hallFame/genph6.jpg";
import {useNavigate} from "react-router-dom";

const slides = [
    {
        img: imgfame7,
        title: "Handcrafted with Heritage",
        text: "Discover our collection of traditional wicker baskets, each piece telling a story of generations of craftsmanship.",
    },
    {
        img: imgfame3,
        title: "Natural Materials",
        text: "Timeless designs made with natural fibers and care.",
    },
    {
        img: imgfame6,
        title: "Crafted to Last",
        text: "Durable products designed for everyday living.",
    },
];

export default function HeroSlider() {
    const [active, setActive] = useState(0);
    const navigate = useNavigate();

    // autoplay
    useEffect(() => {
        const interval = setInterval(() => {
            setActive((prev) => (prev + 1) % slides.length);
        }, 4500);

        return () => clearInterval(interval);
    }, []);

    const prevSlide = () => {
        setActive((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setActive((prev) => (prev + 1) % slides.length);
    };

    return (
        <section id="hero-slider" className="relative h-[600px] overflow-hidden font-script">
            <div className="relative w-full h-full">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-1000 ${
                            index === active ? "opacity-100 z-10" : "opacity-0 z-0"
                        }`}
                    >
                        <img
                            src={slide.img}
                            alt={slide.title}
                            className="w-full h-full object-cover"
                        />

                        <div className="absolute inset-0 bg-black/30" />

                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="text-center text-white max-w-2xl px-6">
                                <h2 className="text-5xl font-serif font-bold mb-6">
                                    {slide.title}
                                </h2>
                                <p className="text-xl mb-8 opacity-90">
                                    {slide.text}
                                </p>
                                <button onClick={() => navigate(`/products`)} className="bg-custom-green hover:bg-light-green text-white px-8 py-3 rounded-lg font-medium transition-colors duration-300">
                                    Shop Collection
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Prev */}
            <button
                onClick={prevSlide}
                className="absolute left-6 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-brand-green w-12 h-12 rounded-full flex items-center justify-center transition-all shadow-lg z-20"
            >
                <i className="fas fa-chevron-left"></i>
            </button>

            {/* Next */}
            <button
                onClick={nextSlide}
                className="absolute right-6 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-brand-green w-12 h-12 rounded-full flex items-center justify-center transition-all shadow-lg z-20"
            >
                <i className="fas fa-chevron-right"></i>
            </button>
        </section>
    );
}